import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { Storage } from "../../../lib/localstorege.service";
import { betSlipVisibleSubject } from "../../../store/betslip.store";
import { initialLeftMenu } from "../../../lib/misc.functions";
var AltenarGamePlayer = function () {
    var userToken = Storage.get('token');
    var queryParams = new URLSearchParams({
        userToken: userToken || '',
        isTest: window.location.origin.includes('test') || window.location.origin.includes('localhost') ? "true" : "false",
    });
    var widgetUrl = "".concat(window.location.origin, "/assets/altenar-wsdk/altenar-wsdk.html?").concat(queryParams.toString());
    useEffect(function () {
        document.body.style.overflow = 'hidden';
        return function () {
            document.body.style.overflow = 'auto';
        };
    }, []);
    return (_jsx("iframe", { title: 'Altenar Sportsbook', style: {
            width: '100%',
            height: '100%',
            border: 'none',
            minHeight: 'calc(100dvh - 150px)'
        }, allow: "fullscreen; autoplay", src: widgetUrl }, void 0));
};
export default function AltenarGames() {
    useEffect(function () {
        initialLeftMenu(false);
        betSlipVisibleSubject.next(false);
        return function () {
            initialLeftMenu(true);
            betSlipVisibleSubject.next(true);
        };
    }, []);
    return _jsx(AltenarGamePlayer, {}, void 0);
}
